import React, { KeyboardEvent } from 'react';

import styled from 'styled-components';

import { FormState, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import UIFormItem, { EUIFormItemVariant } from '@aquariuxfintech/aqx-trader-react-ui/form';
import UIInput, { EUIInputVariant } from '@aquariuxfintech/aqx-trader-react-ui/input';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { ISignUpDemoValues } from '@aqx-core/common/hooks/form/use-sign-up-demo-form';
import { useFirstDemoTenantProduct } from '@aqx-core/common/services/company';
import { getEnterKeycode } from '@aqx-core/common/utils/keyboard';

interface ISignUpNameFieldFormProps {
  name: string;
  firstName: string;
  lastName: string;
  formState: FormState<ISignUpDemoValues>;
  submit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
  register: UseFormRegister<ISignUpDemoValues>;
}

const SignUpNameFieldForm: FCC<ISignUpNameFieldFormProps> = (props) => {
  const { name, firstName, lastName, formState, submit, register } = props;
  const { t } = useTranslation();

  const { isCentroidDemo } = useFirstDemoTenantProduct();

  const {
    errors: { name: nameError, firstName: firstNameError, lastName: lastNameError }
  } = formState;

  const handleKeyDown = (event: KeyboardEvent) => {
    if (getEnterKeycode(event)) {
      event.preventDefault();
      submit();
    }
  };

  if (isCentroidDemo) {
    return (
      <StyledContainer>
        <UIFormItem variant={EUIFormItemVariant.ITEM_WITH_FIELD_LABEL} label={t('First Name')} size="large">
          <UIInput
            {...register('firstName')}
            variant={EUIInputVariant.BORDERED_TEXT}
            placeholder={t('Enter your first name')}
            value={firstName}
            error={firstNameError?.message}
            onKeyDown={handleKeyDown}
            dataTestId={EDataTestId.DEMO_SIGN_UP_NAME_INPUT}
            size="large"
          />
        </UIFormItem>
        <UIFormItem variant={EUIFormItemVariant.ITEM_WITH_FIELD_LABEL} label={t('Last Name')} size="large">
          <UIInput
            {...register('lastName')}
            variant={EUIInputVariant.BORDERED_TEXT}
            placeholder={t('Enter your last name')}
            value={lastName}
            error={lastNameError?.message}
            onKeyDown={handleKeyDown}
            dataTestId={EDataTestId.DEMO_SIGN_UP_NAME_INPUT}
            size="large"
          />
        </UIFormItem>
      </StyledContainer>
    );
  }

  return (
    <UIFormItem variant={EUIFormItemVariant.ITEM_WITH_FIELD_LABEL} label={t('Name')} size="large">
      <UIInput
        {...register('name')}
        variant={EUIInputVariant.BORDERED_TEXT}
        placeholder={t('Enter your name')}
        value={name}
        error={nameError?.message}
        onKeyDown={handleKeyDown}
        dataTestId={EDataTestId.DEMO_SIGN_UP_NAME_INPUT}
        size="large"
      />
    </UIFormItem>
  );
};

export default SignUpNameFieldForm;

const StyledContainer = styled.div`
  display: flex;
  gap: 16px;
`;
